import { hasAnalyticsConsent } from '../services/cookiePreferencesService';
import { getAccessToken } from '../utility/tokenStorage';
import { isSwitchedUser } from '../auth/tokenUtils';

export function shouldTrackAnalytics(): boolean {
    const access = getAccessToken();
    if (isSwitchedUser(access)) {
        return false;
    }

    return hasAnalyticsConsent();
}
